import type { AgentSkillFile } from '../../../../api/agent-skills';
import type { FileTreeNode } from '../types';

export function buildFileTree(files: AgentSkillFile[]): FileTreeNode[] {
  const root: FileTreeNode[] = [];

  for (const file of files) {
    const parts = file.path.split('/');
    let current = root;

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      const isLast = i === parts.length - 1;
      const existingIdx = current.findIndex((n) => n.name === part);

      if (existingIdx >= 0) {
        if (isLast) {
          current[existingIdx].file = file;
        } else {
          current = current[existingIdx].children;
        }
      } else {
        const node: FileTreeNode = {
          name: part,
          path: parts.slice(0, i + 1).join('/'),
          isDir: !isLast,
          children: [],
          file: isLast ? file : undefined,
        };
        current.push(node);
        if (!isLast) {
          current = node.children;
        }
      }
    }
  }

  // Sort: dirs first, then files alphabetically
  const sortNodes = (nodes: FileTreeNode[]) => {
    nodes.sort((a, b) => {
      if (a.isDir && !b.isDir) {
        return -1;
      }
      if (!a.isDir && b.isDir) {
        return 1;
      }
      return a.name.localeCompare(b.name);
    });
    nodes.forEach((n) => sortNodes(n.children));
  };
  sortNodes(root);

  return root;
}
